// @flow
import {graphql} from 'react-relay'
import createMutationPromise, {type MutationInput} from '../createMutationPromise'
import type {
  AddProposalInput as Input,
  AddProposalMutationResponse as Response,
} from './__generated__/AddProposalMutation.graphql'

const mutation = graphql`
  mutation AddProposalMutation($input: AddProposalInput!) {
    addProposal(input: $input) {
      proposalEdge {
        node {
          id
          databaseId
          reviewStatus
          expectedResponseCount

          tension {
            agendaLabel
            body
            createdAt
            databaseId
            meetingType
            processed

            circle {
              databaseId
            }

            person {
              databaseId
            }
          }
          ...Builder_proposal
          ...Delete_proposal
          ...ProposeNowContainer_proposal
        }
      }
    }
  }
`

export type {Input, Response}

export default (input: MutationInput<Input>): Promise<Response> => {
  const variables = {input}

  const configs = [{
    type: 'RANGE_ADD',
    parentID: input.personDatabaseId,
    connectionInfo: [],
    edgeName: 'proposalEdge',
  }]

  return createMutationPromise({
    mutation,
    variables,
    configs,
  })
}
